import api from './api';
import { toast } from 'react-toastify';
import i18n from '../i18n';
import { IDbApplicant, IKpu, ITank } from 'interfaces/applicant.interface';
import { IBasicResponse } from 'interfaces/shared.interface';

const _resourceUrl = '/front';

export const getApplicant = (): Promise<IDbApplicant> => {
  return api.get(`${_resourceUrl}/get-db-applicant`);
};

export const getZipFilename = (): Promise<string> => {
  return api.get(`${_resourceUrl}/get-zip-filename`);
};

export const createKpu = (objectId: number): Promise<IBasicResponse> => {
  return api.post(`${_resourceUrl}/kpu/add`, { objectId });
};

export const updateKpu = (data: IKpu): Promise<IBasicResponse> => {
  return api.post(`${_resourceUrl}/kpu/update`, data);
};

export const updateTank = (data: ITank): Promise<IBasicResponse> => {
  return api.post(`${_resourceUrl}/tank/update`, data);
};

export const updateQoldauToken = (qoldauToken: string): Promise<boolean> => {
  return api.post(`${_resourceUrl}/applicant/qoldautoken/update`, { qoldauToken });
};

export const downloadZip = (id: number): Promise<void> => {
  const params = { id };
  return api
    .get(`${_resourceUrl}/download-zip`, { params, responseType: 'blob' })
    .then((res) => {
      try {
        return {
          fileName: res.headers['content-disposition'].replace(/"/g, '').split('filename=')[1],
          blob: res.data,
        };
      } catch (e) {
        return {
          fileName: 'oil_track.zip',
          blob: res.data,
        };
      }
    })
    .then(({ fileName, blob }) => {
      if (blob?.size > 0) {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error(i18n.t('errors.fileDownload'));
      }
    });
};
